import { Language } from '../../ui/components';
import { AxiosUtilsType, axiosGet, axiosPost } from './axiosUtils';
import './axiosInterceptor';

export const ContentStackService = {
  async getContentStackDataConfig(language: Language): AxiosUtilsType {
    return await axiosGet(`config/data/${language}`);
  },
};

export const ContentStackConsentService = {
  async getContentStackDataConsent(language: Language): AxiosUtilsType {
    return await axiosGet(`config/consent/${language}`);
  },
};

export const ContentStackArticleService = {
  async getArticleByCategoryId(
    language: Language,
    numberOfItem: number,
    categoryId?: string,
    subCategoryId?: string,
  ): AxiosUtilsType {
    return await axiosPost(`config/article`, { language, numberOfItem, categoryId, subCategoryId });
  },
};
